import React, { useContext } from 'react';
import Head from 'next/head';
import { LandingContext } from '~/src/containers/ContextContainer';
import type { ApiCity } from '~/src/services/api/api-content/geography/types';

const IS_GTM_DISABLED = process.env.NEXT_PUBLIC_GTM_DISABLED === '1';

export interface ISeoHead {
    seo: {
        title: string;
        description: string;
        robots?: string;
    };
    canonicalHref: string;
}

export const prepareSeo = (seoTag: string, city: Partial<ApiCity>): string => {
    return seoTag
        .replace('#CITY_IN#', city.pred_name)
        .replace('#CITY_PHONE#', `+7 (${city.phone_code}) ${city.sale_phone}`);
};

const SeoHead = ({ seo, canonicalHref }: ISeoHead): JSX.Element => {
    const { city } = useContext(LandingContext);

    return <>
        <Head>
            <title>{seo && prepareSeo(seo.title, city)}</title>
            <meta name='description' content={seo && prepareSeo(seo.description, city)}/>
            {seo && seo.robots &&
                <meta name='robots' content={seo.robots}/>
            }
            {IS_GTM_DISABLED
                ? <script src='/landing/js/gtmDevStub.js'/>
                : <>
                    <script
                        dangerouslySetInnerHTML={{
                            __html: `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-M43KXLC');
                        `,
                        }}
                    />
                    <script async src='/landing/js/mailRuCounter.js'/>
                    <script async src='https://www.googleoptimize.com/optimize.js?id=OPT-MSHKM9J'/>
                    <script
                        dangerouslySetInnerHTML={{
                            __html: `
                        var hs = document.location.host, pt = document.location.pathname, ct_mod_id,
                        city = {'voronezh':'56b86c19','interzet':'b6a42994','volgograd':'b17dd8bd','bryansk':'415716b8','lipetsk':'fa1db2c8','izhevsk':'04cbca32','barnaul':'fd9f8aaa','rostov':'d77606bb','irkutsk':'c298de68','saratov':'b928c483','chelny':'81ecd81d','kirov':'e2a5f258','engels':'e6f706fe','syzran':'61f2c9df','kurgan':'fcae604f','samara':'a795059f','penza':'c02cfc1f','ryazan':'f51099bf','ekat':'800e89f0','kursk':'174aa129','tver':'fcaac927','oren':'cba316c3','tomsk':'aa73d22a','cheb':'847cacfa','kazan':'25ae1422','tula':'9be219d6','perm':'15d929cc','chel':'ae02cd60','omsk':'22394c85','krsk':'bc67c8be','ulsk':'7473cd01','vlz':'98707bb8','nsk':'be63854d','yar':'961fd096','yola':'4d07d203','ufa':'f147df69','tmn':'1eae2f1a','mgn':'2ede10e5','dzr':'c164207f','nn':'2f7b80a2','nk':'907b0dd2'};
                        ct_mod_id = 'b6a42994'; for (el in city) { if (pt.indexOf(el)>'-1'||hs.indexOf(el) >'-1'){ ct_mod_id = city[el]; break; } }
                        (function(w,d,n,c){w.CalltouchDataObject=n;w[n]=function(){w[n]["callbacks"].push(arguments)};
                        if(!w[n]["callbacks"]){w[n]["callbacks"]=[]}w[n]["loaded"]=false;if(typeof c!=="object")
                        {c=[c]}w[n]["counters"]=c;for(var i=0;i<c.length;i+=1){p(c[i])}function p(cId)
                        {var a=d.getElementsByTagName("script")[0],s=d.createElement("script"),i=function()
                        {a.parentNode.insertBefore(s,a)};s.type="text/javascript";s.async=true;
                        s.src="https://mod.calltouch.ru/init.js?id="+cId;if(w.opera=="[object Opera]")
                        {d.addEventListener("DOMContentLoaded",i,false)}else{i()}}})(window,document,"ct",ct_mod_id);`,
                        }}
                    />
                    <link rel='canonical' href={canonicalHref}/>
                </>
            }
        </Head>
    </>;
};

export default SeoHead;
